import React from 'react'
import "../../Components/WeAreYMC/WeAreYMC.css"
import StartUpLogo from "../../Photos/STARTUP_LOGO.png"


    const TrustedUs = () => {
  return (
    <div className='WeAreYMCFirstBlockTrustedLogosDiv'>
    <div className='WeAreYMCFirstBlockTrustedLogosTitle'>Ellos han confiado en +yomecontrolo</div>
    <div className='WeAreYMCFirstBlockTrustedLogosFlex'>
        <div className='WeAreYMCFirstBlockTrustedLogosBlock'  style={{height:"13vh"}} >
            <img alt="Logo de Start-Up Chile" className="WeAreYMCFirstBlockTrustedLogosImage" src={StartUpLogo}/>
            <div className='WeAreYMCFirstBlockTrustedLogosText'>Ganadores</div>
        </div>
        <div className='WeAreYMCFirstBlockTrustedLogosBlock' /* style={{height:"12vh"}} */>
            <img alt="Logo de KnowHub" className="WeAreYMCFirstBlockTrustedLogosImage" src="https://static.yomecontrolo.cl/public/img/home/KNOWHUB_LOGO.png"/>
        </div>
        <div className='WeAreYMCFirstBlockTrustedLogosBlock' /* style={{height:"7vh"}} */>
            <img alt="Logo de Desafío Avante" className="WeAreYMCFirstBlockTrustedLogosImage" src="https://static.yomecontrolo.cl/public/img/home/AVANTE_LOGO.png"/>
            <div className='WeAreYMCFirstBlockTrustedLogosText'>1° Lugar</div>
        </div>
        <div className='WeAreYMCFirstBlockTrustedLogosBlock' /* style={{height:"5vh"}} */>
            <img alt="Logo de YLAI" className="WeAreYMCFirstBlockTrustedLogosImage" src="https://static.yomecontrolo.cl/public/img/home/YLAI_LOGO.png"/>
            <div className='WeAreYMCFirstBlockTrustedLogosText'>Ganadores</div>
        </div>
    </div>

</div>
  )
}

export default TrustedUs;